import { AxiosInstance } from 'axios';
import { BlogComment } from 'referral-types';
import { simulate } from './utils';

export const baseEndpoint = 'blog-comment';

export class BlogCommentApi {
  private apiInstance: AxiosInstance;

  constructor(apiInstance: AxiosInstance) {
    this.apiInstance = apiInstance;
  }

  async getComments(blogPostId: string): Promise<Array<BlogComment>> {
    await simulate();
    const response = await this.apiInstance.get(`/blog-post/${blogPostId}`);

    return response.data;
  }

  async createComment(blogPostId: string, content: string): Promise<BlogComment> {
    await simulate();
    const response = await this.apiInstance.post(`/blog-post/${blogPostId}`, { content });

    return response.data;
  }

  async deleteComment(commentId: string): Promise<{ id: string; deleted: boolean }> {
    await simulate();
    const response = await this.apiInstance.delete(`/${commentId}`);

    return response.data;
  }
}
